"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var SubtleTextField_1 = __importDefault(require("../../TeamView/styles/SubtleTextField"));
var TextInput = function (_a) {
    var align = _a.align, alignItems = _a.alignItems, width = _a.width, isNumber = _a.isNumber, props = __rest(_a, ["align", "alignItems", "width", "isNumber"]);
    return ((0, jsx_runtime_1.jsx)(SubtleTextField_1.default, __assign({ style: { justifyContent: align, alignItems: alignItems, width: width }, type: "text", variant: 'standard', InputProps: {
            disableUnderline: true,
            autoComplete: 'off',
            inputProps: {
                style: {
                    textAlign: isNumber ? 'right' : 'left',
                    paddingRight: isNumber ? 12 : 8,
                },
            },
        } }, props)));
};
exports.default = TextInput;
